// @ts-nocheck



import React, { PureComponent } from 'react';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import qs from 'query-string';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';








import {
  monthlyWashingPlanApi } from

'./../../../lib/api';
import {
  getListInitialState,
  setQueryParams,
  formatDateTimeToString,
  convertContractorToString } from
'./../../../lib/helpers';
import { monthlyWashingPlanStatuses } from './../../../lib/enum';

import { Table } from './../../../components/ui';
import { Section } from './../../../components/layout';
import Header from './../../../components/layout/Header';
import Filter from './Filter';
import { notificationLoading } from './../../../components/Notifications';

import { withUserAccess } from './../../withUserAccess';

import { setFilter } from '../../../ducks/persistFilters';


import { addPlanAccessRight } from './accessRight';












export class MonthlyWashingPlansList extends PureComponent {
  state = {
    ...getListInitialState(),
    filterPath: window.location.pathname
  };

  static defaultProps = {
    location: {}
  };

  async deleteMonthlyWashingPlan(id) {
    const { page } = this.state;
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await monthlyWashingPlanApi.deleteMonthlyWashingPlan(id);
      notification.success({
        message: 'Успешное удаление',
        description: `Расчет успешно удален`
      });
      await this.fetchMonthlyWashingPlans(page);
    } catch (error) {
      notification.error({
        message: 'Ошибка при удалении',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  }

  columns = [
  {
    title: 'Номер',
    dataIndex: 'id'
  },
  {
    title: 'Филиал',
    dataIndex: 'orgUnitName'
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    render: (status) =>
    monthlyWashingPlanStatuses[status]
  },
  {
    title: 'Период проведения',
    dataIndex: 'date',
    render: (month) => formatDateTimeToString(month, 'MMMM YYYY')
  },
  {
    title: 'Количество ТС',
    dataIndex: 'vehicleCount'
  },
  {
    title: 'Подрядчик',
    dataIndex: 'contractor',
    render: (contractor) => convertContractorToString(contractor)
  },
  {
    title: 'Сумма в руб. без НДС',
    dataIndex: 'price',
    render: (price) => `${price} руб.`
  }];


  fetchMonthlyWashingPlans = async (
  page = 1,
  params = {}) =>
  {
    try {
      const { filterPath } = this.state;
      const filter = this.props.persistFilters[filterPath] || {};
      this.setState({ loading: true });
      const {
        data,
        totalCount
      } = await monthlyWashingPlanApi.fetchMonthlyWashingPlans({
        ...filter,
        page,
        ...params
      });
      setQueryParams({ page });
      this.setState({ data, totalCount, page });
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err && err.message
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  setPersistFilter = async (values) => {
    const { filterPath } = this.state;
    await this.props.setFilter({
      path: filterPath,
      values
    });
  };

  applyFilter = async (filter = {}) => {
    await this.setPersistFilter(filter);
    await this.fetchMonthlyWashingPlans();
  };

  cleanFilter = this.applyFilter;

  async componentDidMount() {
    const { page, ...filter } = qs.parse(window.location.search);
    if (!isEmpty(filter)) {
      await this.setPersistFilter(filter);
    }
    await this.fetchMonthlyWashingPlans(page);
  }

  handleRowClick = (id) =>
  navigate(`/budget/monthly-washing-plans/${id}`);

  canAdd = () =>
  this.props.userAccess.some((access) => addPlanAccessRight.includes(access));

  render() {
    const { location } = this.props;
    const {
      data,
      totalCount,
      page,
      pageSize,
      loading,
      filterPath
    } = this.state;
    const canAdd = this.canAdd();
    const filter = this.props.persistFilters[filterPath];

    return (
      <>
        <Header
          left={<h1>План моек</h1>}
          right={
          canAdd &&
          <Link to="/budget/monthly-washing-plans/new">
                <Button type="primary" data-cy="add">
                  Создать
                </Button>
              </Link>

          } />

        <Section>
          <Filter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            columns={this.columns}
            data={data.map((model) => ({
              ...model,
              key: model.id
            }))}
            fetch={this.fetchMonthlyWashingPlans}
            loading={loading}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }} />

        </Section>
      </>);

  }
}

export default connect(
  (state) => ({
    persistFilters: state.persistFilters
  }),
  {
    setFilter
  }
)(withUserAccess(MonthlyWashingPlansList));
